import { FormControl, Input, InputLabel } from "@mui/material";
import React from "react";
import CustomView from "../dataDisplay/CustomView";
import CoreTypographyCaption from "../dataDisplay/CoreTypographyCaption";

export default function CoreInput(props) {
  const { id, formikProps } = props;

  return props.edit !== false ? (
    <FormControl
      fullWidth={true}
      style={{
        marginBottom: 8,
      }}
    >
      {props.shrink ? (
        <InputLabel shrink={true} style={{ marginLeft: -10, color: "#5c5c5c" }}>
          {props.label}
        </InputLabel>
      ) : (
        <InputLabel style={{ marginLeft: -10, color: "#5c5c5c" }}>
          {props.label}
        </InputLabel>
      )}
      <Input fullWidth={true} variant="standard" {...props} />
      <CoreTypographyCaption color="error">
        {formikProps?.touched[id] && formikProps?.errors[id]}
      </CoreTypographyCaption>
    </FormControl>
  ) : (
    <CustomView value={props.value} label={props.label} />
  );
}
